module.exports = __webpack_public_path__ + "img/rho-17-bienenwachs-02.3bb802f9.jpeg";